import createIcon from '../../createIcon';

/**
 * @component @name DensityMedium
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzVjVIMjFWM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxOUgzVjIxSDIxVjE5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxIDExSDNWMTNIMjFWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DensityMedium = createIcon('DensityMedium', [
  ['path', { d: 'M21 3H3V5H21V3Z', key: 'zp4t6d' }],
  ['path', { d: 'M21 19H3V21H21V19Z', key: '1pvyhi' }],
  ['path', { d: 'M21 11H3V13H21V11Z', key: '13jzef' }],
]);

export default DensityMedium;
